export default {
  // Errors
  notFound: 'استان یافت نشد',

  // Words
  enterProvince: 'نام استان را وارد کنید',
  province: 'استان'
}